import React from 'react';
import styled from 'styled-components';

const Root = styled.div`
    animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;
    color: rgba(255, 255, 255, 0.13);
`;

const Skeletize: React.FC = ({children}) => <Root>{children}</Root>;

export default Skeletize;
